import React, { useEffect, useState } from 'react'
import styles from './AddNewDeal.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import SearchInput from 'components/ContentBox/Global/SearchInput/SearchInput'
import useLocalization from 'hooks/useLocalization'
import InputFlagPhone from 'components/ContentBox/Global/InputPhone/InputFlagPhone/InputFlagPhone'
import { superAxiosRequest } from 'axiosApi'
import { observer } from 'mobx-react'
import FormDateSelector from '../../../../../../UI/AsideModal/Form/FormDateSelector'

const AddNewDeal = ({ isEdit, dealId, funnelId }) => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
    setValid,
  } = asideModalStore

  const [client, setClient] = useState(null)
  const [fetchRequireFields, setFetchRequireFields] = useState({
    manager: [],
    dealNameText: null,
  })
  const [isNewClient, setIsNewClient] = useState(isEdit ? false : null)

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      budget: 'Budget',
      city: 'City',
      select_city: 'Select city',
      deal_name: 'Deal name',
      responsible: 'Responsible',
      select_responsible: 'Select responsible',
      branch: 'Branch',
      select_branch: 'Select branch',
      select_program: 'Select program',
      program: 'Program',
      level: 'Level',
      select_level: 'Select level',
      client: 'Client',
      name: 'Name',
      client_type: 'Select client type',
      new_client: 'New client',
      existing_client: 'Existing client',

      planned_specialty: 'Какую специальность вы планируете выбрать',
      country: 'Страна',
      scores: 'Оценки',
      note: 'Примечание',
      meeting_format: 'Формат встречи',
      consultation_date: 'Время и дата консультации',
      program_selection: 'Выбор программ',
      year_of_study: 'Класс/Курс',
      birth_date: 'День рождения',
      institution: 'Школа/универ',
      comment: 'Комментарий',
      planned_admission_year: 'Планируемый год поступления',
      meeting_summary: 'Краткое описание встречи',
      specialty: 'Специальность',
      is_documents_received: 'Документы получены',
      country_of_admission: 'Страна поступления',
      institution_name: 'Название учебного заведения',
      partner_name: 'Название партнера',
      program_cost: 'Стоимость программы',
      posttraining_perspectives: 'Перспективы после обучения',
      client_annual_budget: 'Бюджет клиента на год',
      is_visa_required: 'Нужна виза',
      visa_appointment: 'Запись на визу',
      source: 'Источник',
      bonus_from: 'Бонус (указать имя от кого)',
      reminder_date: 'Напомнить о нас',
      flow: 'Поток',
      certificate: 'Сертификат',
      cover_letter: 'Сопроводительное письмо',
      heard_from: 'Откуда узнали',

      select_meeting_format: 'Выберите формат встречи',
      select_year_of_study: 'Выберите класс/курс',
      select_country_of_admission: 'Выберите страну поступления',
      select_posttraining_perspectives: 'Выберите перспективы',
      select_flow: 'Выберите поток',
      select_program_selection: 'Выберите программу',
    },
  })

  const updateValidation = () => {
    const customValidations = {}

    const baseValidations = modalValue.hasOwnProperty('client_text_phone')
      ? {
          client_text_name: 'required',
          client_text_phone: 'required',
        }
      : {
          client: 'required',
        }

    setValid({
      ...baseValidations,
      ...customValidations,
    })
  }

  useEffect(() => {
    updateValidation()
  }, [modalValue.client_text_phone, modalValue.client])

  useEffect(() => {
    let isMounted = true

    const fetchData = async () => {
      try {
        const [managerResponse, dealNameResponse] = await Promise.all([
          superAxiosRequest({
            link: 'integration/employees',
            method: 'get',
            crm: true,
            params: { limit: 9999 },
          }),
          superAxiosRequest({
            link: 'integration/deal_name_next',
            method: 'get',
            crm: true,
          }),
        ])

        if (isMounted) {
          const responsibleOptions = managerResponse.data.result.map(
            (responsible) => ({
              id: responsible.id,
              name: responsible.full_name,
            }),
          )

          setFetchRequireFields({
            manager: responsibleOptions,
            dealNameText: dealNameResponse.data.deal_name,
          })
        }
      } catch (error) {
        console.error(error)
      }
    }

    fetchData()

    return () => {
      isMounted = false
    }
  }, [])

  const getStudentList = (value) => {
    const clientData = Array.isArray(value) ? value[0] : value
    setClient(clientData?.name)
    changeValues(clientData?.id, 'client')
    changeValues(clientData?.name, 'client_name')
  }

  const renderClientTypeSelection = () => (
    <FormField>
      <FormLabel>{translate.client_type}:</FormLabel>
      <div className={styles.btns}>
        <button
          type='button'
          className={isNewClient === true ? styles.active : ''}
          onClick={() => setIsNewClient(true)}
        >
          {translate.new_client}
        </button>
        <button
          type='button'
          className={isNewClient === false ? styles.active : ''}
          onClick={() => setIsNewClient(false)}
        >
          {translate.existing_client}
        </button>
      </div>
    </FormField>
  )

  const renderClientFields = () => {
    if (!isEdit && isNewClient === null) {
      return renderClientTypeSelection()
    }

    if (isNewClient) {
      return (
        <>
          <FormField>
            <FormLabel isRequired>Имя клиента:</FormLabel>
            <FormInput isError={check('client_text_name')}>
              <input
                placeholder='Имя клиента'
                type='text'
                value={modalValue.client_text_name || ''}
                onChange={(e) =>
                  changeValues(e.target.value, 'client_text_name')
                }
                maxLength={30}
              />
            </FormInput>
          </FormField>
          <FormField>
            <FormLabel isRequired>Телефон клиента:</FormLabel>
            <InputFlagPhone
              error={check('client_text_phone')}
              value={modalValue.client_text_phone || ''}
              onChange={(val) => changeValues(val, 'client_text_phone')}
            />
          </FormField>
        </>
      )
    }

    return (
      <FormField>
        <FormLabel>{translate?.client}:</FormLabel>
        <SearchInput
          link='integration/clients'
          placeholder={translate?.name}
          new_key='name'
          backFunction={getStudentList}
          crm={true}
          initialValue={client || modalValue.client_name}
          error={check('client')}
        />
      </FormField>
    )
  }

  const CheckboxField = ({ label, fieldKey, error }) => (
    <FormField>
      <div
        className={styles.checkboxWrapper}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          marginTop: '8px',
        }}
      >
        <input
          type='checkbox'
          id={fieldKey}
          checked={!!modalValue[fieldKey]}
          onChange={(e) => changeValues(e.target.checked, fieldKey)}
          style={{ width: '18px', height: '18px', cursor: 'pointer' }}
        />
        <label
          htmlFor={fieldKey}
          style={{ cursor: 'pointer', userSelect: 'none' }}
        >
          {label}
        </label>
      </div>
      {error && <div className={styles.errorText}>{error}</div>}
    </FormField>
  )

  return (
    <div className={styles.groupForm}>
      {!isEdit && isNewClient === null ? (
        renderClientTypeSelection()
      ) : (
        <>
          <FormField>
            <FormLabel>{translate?.deal_name}:</FormLabel>
            <FormInput isError={check('deal_name')}>
              <input
                placeholder={translate?.deal_name}
                type='text'
                value={
                  modalValue.deal_name || fetchRequireFields.dealNameText || ''
                }
                onChange={(e) => changeValues(e.target.value, 'deal_name')}
                maxLength={100}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel>{translate.bonus_from}:</FormLabel>
            <FormInput>
              <input
                type='text'
                placeholder={translate.bonus_from}
                value={modalValue.bonus_from || ''}
                onChange={(e) => changeValues(e.target.value, 'bonus_from')}
              />
            </FormInput>
          </FormField>

          {isEdit && isNewClient === false && (
            <>
              <FormField>
                <FormLabel>Причина отказа:</FormLabel>
                <SelectCustom
                  placeholder='Выберите причину'
                  apiLinkCRM='settings/project_settings/deal_reject_reason_choices'
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.reject_reason}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(val) => changeValues(val.name, 'reject_reason')}
                  isSearchable
                  error={check('reject_reason')}
                />
              </FormField>

              {/*<FormField>*/}
              {/*  <FormLabel>Вид обучения:</FormLabel>*/}
              {/*  <SelectCustom*/}
              {/*    placeholder='Вид обучения'*/}
              {/*    apiLinkCRM='settings/project_settings/deal_learning_type_choices'*/}
              {/*    apiGetResult={(result) => result.value.choices}*/}
              {/*    valueID={modalValue.learning_type}*/}
              {/*    optionLabelKey='name'*/}
              {/*    optionValueKey='name'*/}
              {/*    onChange={(val) => changeValues(val.name, 'learning_type')}*/}
              {/*    isSearchable*/}
              {/*    error={check('learning_type')}*/}
              {/*  />*/}
              {/*</FormField>*/}

              {/*<FormField>*/}
              {/*  <FormLabel>Тип обучения:</FormLabel>*/}
              {/*  <SelectCustom*/}
              {/*    placeholder='Тип обучения'*/}
              {/*    apiLinkCRM='settings/project_settings/deal_education_type_choices'*/}
              {/*    apiGetResult={(result) => result.value.choices}*/}
              {/*    valueID={modalValue.education_type}*/}
              {/*    optionLabelKey='name'*/}
              {/*    optionValueKey='name'*/}
              {/*    onChange={(val) => changeValues(val.name, 'education_type')}*/}
              {/*    isSearchable*/}
              {/*    error={check('education_type')}*/}
              {/*  />*/}
              {/*</FormField>*/}

              {/*<FormField>*/}
              {/*  <FormLabel>Цель обучения:</FormLabel>*/}
              {/*  <SelectCustom*/}
              {/*    placeholder='Цель обучения'*/}
              {/*    apiLinkCRM='settings/project_settings/deal_learning_goal_choices'*/}
              {/*    apiGetResult={(result) => result.value.choices}*/}
              {/*    valueID={modalValue.learning_goal}*/}
              {/*    optionLabelKey='name'*/}
              {/*    optionValueKey='name'*/}
              {/*    onChange={(val) => changeValues(val.name, 'learning_goal')}*/}
              {/*    isSearchable*/}
              {/*    error={check('learning_goal')}*/}
              {/*  />*/}
              {/*</FormField>*/}

              {/*<FormField>*/}
              {/*  <FormLabel>Дни обучения:</FormLabel>*/}
              {/*  <SelectCustom*/}
              {/*    placeholder='Дни обучения'*/}
              {/*    apiLinkCRM='settings/project_settings/deal_learning_days_choices'*/}
              {/*    apiGetResult={(result) => result.value.choices}*/}
              {/*    valueID={modalValue.learning_days}*/}
              {/*    optionLabelKey='name'*/}
              {/*    optionValueKey='name'*/}
              {/*    onChange={(val) => changeValues(val.name, 'learning_days')}*/}
              {/*    isSearchable*/}
              {/*    error={check('learning_days')}*/}
              {/*  />*/}
              {/*</FormField>*/}
            </>
          )}

          <FormField>
            <FormLabel>{translate?.responsible}:</FormLabel>
            <SelectCustom
              placeholder={translate?.select_responsible}
              options={fetchRequireFields.manager}
              sortKey='name'
              valueID={modalValue.manager}
              onChange={(manager) => changeValues(manager.id, 'manager')}
              isSearchable
              error={check('manager')}
            />
          </FormField>

          {renderClientFields()}

          <FormField>
            <FormLabel>{translate?.budget}, ₸:</FormLabel>
            <FormInput isError={check('budget')}>
              <input
                placeholder={translate?.budget}
                type='number'
                value={modalValue.budget || ''}
                onChange={(e) => changeValues(e.target.value, 'budget')}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel>{translate?.city}:</FormLabel>
            <SelectCustom
              placeholder={translate?.select_city}
              apiLinkCRM='integration/cities'
              apiConfParams={{ limit: 99 }}
              sortKey='name'
              valueID={modalValue.city}
              onChange={(city) => changeValues(city.id, 'city')}
              isSearchable
              error={check('city')}
            />
          </FormField>

          <FormField>
            <FormLabel>{translate.year_of_study}:</FormLabel>
            <SelectCustom
              placeholder={translate.select_year_of_study}
              apiLinkCRM='settings/project_settings/deal_year_of_study_choices'
              apiGetResult={(result) => result.value.choices}
              valueID={modalValue.year_of_study}
              optionLabelKey='name'
              optionValueKey='name'
              onChange={(val) => changeValues(val.name, 'year_of_study')}
              isSearchable
            />
          </FormField>

          <FormField>
            <FormLabel>{translate.institution}:</FormLabel>
            <FormInput>
              <input
                type='text'
                placeholder={translate.institution}
                value={modalValue.institution || ''}
                onChange={(e) => changeValues(e.target.value, 'institution')}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel>{translate.planned_admission_year}:</FormLabel>
            <FormInput>
              {/*<input*/}
              {/*  type='text'*/}
              {/*  placeholder={translate.planned_admission_year}*/}
              {/*  value={modalValue.planned_admission_year || ''}*/}
              {/*  onChange={(e) =>*/}
              {/*    changeValues(e.target.value, 'planned_admission_year')*/}
              {/*  }*/}
              {/*/>*/}
              <SelectCustom
                placeholder={translate.planned_admission_year}
                apiLinkCRM='settings/project_settings/deal_planned_admission_year_choices'
                apiGetResult={(result) => result.value.choices}
                valueID={modalValue.planned_admission_year}
                optionLabelKey='name'
                optionValueKey='name'
                onChange={(val) =>
                  changeValues(val.name, 'planned_admission_year')
                }
                isSearchable
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel>{translate?.branch}:</FormLabel>
            <SelectCustom
              placeholder={translate?.select_branch}
              apiLinkCRM='integration/branches'
              sortKey='name'
              valueID={modalValue.branch}
              onChange={(branch) => changeValues(branch.id, 'branch')}
              isSearchable
              error={check('branch')}
            />
          </FormField>

          <FormField>
            <FormLabel>{translate?.program}:</FormLabel>
            <SelectCustom
              placeholder={translate?.select_program}
              apiLinkCRM='integration/programs'
              sortKey='name'
              valueID={modalValue.program}
              onChange={(program) => changeValues(program.id, 'program')}
              isSearchable
              error={check('program')}
            />
          </FormField>

          <FormField>
            <FormLabel>Уровень английского:</FormLabel>
            {/*<SelectCustom*/}
            {/*  placeholder={translate?.select_level}*/}
            {/*  apiLinkCRM='integration/teaching_levels'*/}
            {/*  sortKey='name'*/}
            {/*  valueID={modalValue.level}*/}
            {/*  onChange={(level) => changeValues(level.id, 'level')}*/}
            {/*  isSearchable*/}
            {/*  error={check('level')}*/}
            {/*/>*/}
            <FormInput isError={check('level_result')}>
              <input
                placeholder={'Уровень английского'}
                type='text'
                value={modalValue.level_result || ''}
                onChange={(e) => changeValues(e.target.value, 'level_result')}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel>{translate.planned_specialty}:</FormLabel>
            {/*<FormInput>*/}
            {/*  <input*/}
            {/*    type='text'*/}
            {/*    placeholder={translate.planned_specialty}*/}
            {/*    value={modalValue.planned_specialty || ''}*/}
            {/*    onChange={(e) =>*/}
            {/*      changeValues(e.target.value, 'planned_specialty')*/}
            {/*    }*/}
            {/*    maxLength={100}*/}
            {/*  />*/}
            {/*</FormInput>*/}
            <SelectCustom
              placeholder={translate.planned_specialty}
              apiLinkCRM='settings/project_settings/deal_planned_specialty_choices'
              apiGetResult={(result) => result.value.choices}
              valueID={modalValue.planned_specialty}
              optionLabelKey='name'
              optionValueKey='name'
              onChange={(val) => changeValues(val.name, 'planned_specialty')}
              isSearchable
            />
          </FormField>

          {/*<FormField>*/}
          {/*  <FormLabel>{translate.country}:</FormLabel>*/}
          {/*  <FormInput>*/}
          {/*    <input*/}
          {/*      type='text'*/}
          {/*      placeholder={translate.country}*/}
          {/*      value={modalValue.country || ''}*/}
          {/*      onChange={(e) => changeValues(e.target.value, 'country')}*/}
          {/*      maxLength={200}*/}
          {/*    />*/}
          {/*  </FormInput>*/}
          {/*</FormField>*/}

          <FormField>
            <FormLabel>{translate.country_of_admission}:</FormLabel>
            <SelectCustom
              placeholder={translate.select_country_of_admission}
              apiLinkCRM='settings/project_settings/deal_country_of_admission_choices'
              apiGetResult={(result) => result.value.choices}
              valueID={modalValue.country_of_admission}
              optionLabelKey='name'
              optionValueKey='name'
              onChange={(val) => changeValues(val.name, 'country_of_admission')}
              isSearchable
            />
          </FormField>

          <FormField>
            <FormLabel>{translate.institution_name}:</FormLabel>
            <FormInput>
              <input
                type='text'
                placeholder={translate.institution_name}
                value={modalValue.institution_name || ''}
                onChange={(e) =>
                  changeValues(e.target.value, 'institution_name')
                }
              />
            </FormInput>
          </FormField>

          {/*<FormField>*/}
          {/*  <FormLabel>{translate.program_selection}:</FormLabel>*/}
          {/*  <SelectCustom*/}
          {/*    placeholder={translate.select_program_selection}*/}
          {/*    apiLinkCRM='settings/project_settings/deal_program_selection_choices'*/}
          {/*    apiGetResult={(result) => result.value.choices}*/}
          {/*    valueID={modalValue.program_selection}*/}
          {/*    optionLabelKey='name'*/}
          {/*    optionValueKey='name'*/}
          {/*    onChange={(val) => changeValues(val.name, 'program_selection')}*/}
          {/*    isSearchable*/}
          {/*  />*/}
          {/*</FormField>*/}

          {/*<FormField>*/}
          {/*  <FormLabel>{translate.scores}:</FormLabel>*/}
          {/*  <FormInput>*/}
          {/*    <input*/}
          {/*      type='text'*/}
          {/*      placeholder={translate.scores}*/}
          {/*      value={modalValue.scores || ''}*/}
          {/*      onChange={(e) => changeValues(e.target.value, 'scores')}*/}
          {/*    />*/}
          {/*  </FormInput>*/}
          {/*</FormField>*/}

          <FormField>
            <FormLabel>{translate.meeting_format}:</FormLabel>
            <SelectCustom
              placeholder={translate.select_meeting_format}
              apiLinkCRM='settings/project_settings/deal_meeting_format_choices'
              apiGetResult={(result) => result.value.choices}
              valueID={modalValue.meeting_format}
              optionLabelKey='name'
              optionValueKey='name'
              onChange={(val) => changeValues(val.name, 'meeting_format')}
              isSearchable
            />
          </FormField>

          <FormField>
            <FormLabel>{translate.consultation_date}:</FormLabel>
            <FormDateSelector
              value={modalValue.consultation_date || ''}
              onChange={(val) => changeValues(val, 'consultation_date')}
              showTimeSelect={true}
              dateFormat='dd.MM.yyyy HH:mm'
              placeholder={translate.consulation_date}
            />
          </FormField>

          {/*<FormField>*/}
          {/*  <FormLabel>{translate.meeting_summary}:</FormLabel>*/}
          {/*  <FormInput>*/}
          {/*    <textarea*/}
          {/*      rows={3}*/}
          {/*      placeholder={translate.meeting_summary}*/}
          {/*      value={modalValue.meeting_summary || ''}*/}
          {/*      onChange={(e) =>*/}
          {/*        changeValues(e.target.value, 'meeting_summary')*/}
          {/*      }*/}
          {/*      style={{*/}
          {/*        width: '100%',*/}
          {/*        resize: 'vertical',*/}
          {/*        padding: '8px',*/}
          {/*        borderRadius: '4px',*/}
          {/*        border: '1px solid #ccc',*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  </FormInput>*/}
          {/*</FormField>*/}

          <FormField>
            <FormLabel>{translate.birth_date}:</FormLabel>
            <FormDateSelector
              value={modalValue.birth_date || ''}
              onChange={(val) => changeValues(val, 'birth_date')}
              dateFormat='dd.MM.yyyy'
              placeholder={translate.birth_date}
            />
          </FormField>

          <CheckboxField
            label={translate.is_documents_received}
            fieldKey='is_documents_received'
          />

          <CheckboxField
            label={translate.is_visa_required}
            fieldKey='is_visa_required'
          />

          <FormField>
            <FormLabel>{translate.visa_appointment}:</FormLabel>
            <FormInput>
              <input
                type='text'
                placeholder={translate.visa_appointment}
                value={modalValue.visa_appointment || ''}
                onChange={(e) =>
                  changeValues(e.target.value, 'visa_appointment')
                }
              />
            </FormInput>
          </FormField>

          {/*<CheckboxField label={translate.certificate} fieldKey='certificate' />*/}

          {/*<CheckboxField*/}
          {/*  label={translate.cover_letter}*/}
          {/*  fieldKey='cover_letter'*/}
          {/*/>*/}

          <FormField>
            <FormLabel>{translate.program_cost}:</FormLabel>
            <FormInput>
              <input
                type='text'
                placeholder={translate.program_cost}
                value={modalValue.program_cost || ''}
                onChange={(e) => changeValues(e.target.value, 'program_cost')}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel>{translate.client_annual_budget}:</FormLabel>
            <FormInput>
              <input
                type='text'
                placeholder={translate.client_annual_budget}
                value={modalValue.client_annual_budget || ''}
                onChange={(e) =>
                  changeValues(e.target.value, 'client_annual_budget')
                }
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel>{translate.posttraining_perspectives}:</FormLabel>
            <SelectCustom
              placeholder={translate.select_posttraining_perspectives}
              apiLinkCRM='settings/project_settings/deal_posttraining_perspectives_choices'
              apiGetResult={(result) => result.value.choices}
              valueID={modalValue.posttraining_perspectives}
              optionLabelKey='name'
              optionValueKey='name'
              onChange={(val) =>
                changeValues(val.name, 'posttraining_perspectives')
              }
              isSearchable
            />
          </FormField>

          {/*<FormField>*/}
          {/*  <FormLabel>{translate.flow}:</FormLabel>*/}
          {/*  <SelectCustom*/}
          {/*    placeholder={translate.select_flow}*/}
          {/*    apiLinkCRM='settings/project_settings/deal_flow_choices'*/}
          {/*    apiGetResult={(result) => result.value.choices}*/}
          {/*    valueID={modalValue.flow}*/}
          {/*    optionLabelKey='name'*/}
          {/*    optionValueKey='name'*/}
          {/*    onChange={(val) => changeValues(val.name, 'flow')}*/}
          {/*    isSearchable*/}
          {/*  />*/}
          {/*</FormField>*/}

          <FormField>
            <FormLabel>{translate.partner_name}:</FormLabel>
            <FormInput>
              <input
                type='text'
                placeholder={translate.partner_name}
                value={modalValue.partner_name || ''}
                onChange={(e) => changeValues(e.target.value, 'partner_name')}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel>{translate.reminder_date}:</FormLabel>
            <FormDateSelector
              value={modalValue.reminder_date || ''}
              onChange={(val) => changeValues(val, 'reminder_date')}
              dateFormat='dd.MM.yyyy'
              placeholder={translate.reminder_date}
            />
          </FormField>

          {/*<FormField>*/}
          {/*  <FormLabel>{translate.heard_from}:</FormLabel>*/}
          {/*  <FormInput>*/}
          {/*    <input*/}
          {/*      type='text'*/}
          {/*      placeholder={translate.heard_from}*/}
          {/*      value={modalValue.heard_from || ''}*/}
          {/*      onChange={(e) => changeValues(e.target.value, 'heard_from')}*/}
          {/*    />*/}
          {/*  </FormInput>*/}
          {/*</FormField>*/}

          <FormField>
            <FormLabel>Откуда пришли:</FormLabel>
            <SelectCustom
              placeholder='Откуда пришли'
              apiLinkCRM='settings/project_settings/deal_source_choices'
              apiGetResult={(result) => result.value.choices}
              valueID={modalValue.source}
              optionLabelKey='name'
              optionValueKey='name'
              onChange={(val) => changeValues(val.name, 'source')}
              isSearchable
              error={check('source')}
            />
          </FormField>

          <FormField>
            <FormLabel>Age:</FormLabel>
            <FormInput>
              <input
                type='text'
                placeholder={'Age'}
                value={modalValue.age || ''}
                onChange={(e) => changeValues(e.target.value, 'age')}
              />
            </FormInput>
          </FormField>

          {/*<FormField>*/}
          {/*  <FormLabel>{translate.note}:</FormLabel>*/}
          {/*  <FormInput>*/}
          {/*    <textarea*/}
          {/*      rows={3}*/}
          {/*      placeholder={translate.note}*/}
          {/*      value={modalValue.note || ''}*/}
          {/*      onChange={(e) => changeValues(e.target.value, 'note')}*/}
          {/*      style={{*/}
          {/*        width: '100%',*/}
          {/*        resize: 'vertical',*/}
          {/*        padding: '8px',*/}
          {/*        borderRadius: '4px',*/}
          {/*        border: '1px solid #ccc',*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  </FormInput>*/}
          {/*</FormField>*/}

          {/*<FormField>*/}
          {/*  <FormLabel>{translate.comment}:</FormLabel>*/}
          {/*  <FormInput>*/}
          {/*    <textarea*/}
          {/*      rows={3}*/}
          {/*      placeholder={translate.comment}*/}
          {/*      value={modalValue.comment || ''}*/}
          {/*      onChange={(e) => changeValues(e.target.value, 'comment')}*/}
          {/*      style={{*/}
          {/*        width: '100%',*/}
          {/*        resize: 'vertical',*/}
          {/*        padding: '8px',*/}
          {/*        borderRadius: '4px',*/}
          {/*        border: '1px solid #ccc',*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  </FormInput>*/}
          {/*</FormField>*/}
        </>
      )}
    </div>
  )
}

export default observer(AddNewDeal)
